module.exports = __webpack_public_path__ + "img/directionRight.b0de334f.svg";